import {connect} from "react-redux";

import OfferForm from "../../../components/Modals/OfferModal/OfferForm";
import {
    checkPromotionCode,
    createCustomer,
    setAddressStripeInfos,
    setCityStripeInfos,
    setEmailStripeInfos,
    setFirstnameStripeInfos,
    setLastnameStripeInfos,
    setOfferPrice,
    setPostalCodeStripeInfos,
    setTelStripeInfos,
    updateCustomer
} from "../../../actions/stripePayment";
import {setUserInfos} from "../../../actions/PlanDemand";

const MapStateToProps = (state) => ({
    offerPrice: state.stripePayment.offerPrice,
    promotionCode: state.stripePayment.promotionCode,
    errorMessage: state.user.errorMessage,
    promotionCodeFlag: state.stripePayment.promotionCodeFlag,
    activationCodeFlag: state.stripePayment.activationCodeFlag,
    customerId: state.stripePayment.customerId,
    userInfos: state.stripePayment.userInfos,
    resetUserInfos: state.user.resetUserInfos

});

const MapDispatchToProps = (dispatch) => ({
    setFirstnameStripeInfos: (firstname) => {
        dispatch(setFirstnameStripeInfos(firstname));
    },
    setLastnameStripeInfos: (lastname) => {
        dispatch(setLastnameStripeInfos(lastname));
    },
    setEmailStripeInfos: (email) => {
        dispatch(setEmailStripeInfos(email));
    },
    setAddressStripeInfos: (address) => {
        dispatch(setAddressStripeInfos(address));
    },
    setCityStripeInfos: (city) => {
        dispatch(setCityStripeInfos(city));
    },
    setTelStripeInfos: (tel) => {
        dispatch(setTelStripeInfos(tel));
    },
    setPostalCodeStripeInfos: (postalCode) => {
        dispatch(setPostalCodeStripeInfos(postalCode));
    },
    checkPromotionCode: () => {
        dispatch(checkPromotionCode());
    },
    createCustomer: () => {
        dispatch(createCustomer());
    },
    setOfferPrice: (price) => {
        dispatch(setOfferPrice(price));
    },
    updateCustomer: () => {
        dispatch(updateCustomer());
    },
    setUserInfos: (value, type) => {
        dispatch(setUserInfos(value, type));
    },
});

export default connect(MapStateToProps, MapDispatchToProps)(OfferForm);